import React from 'react';
import { Helmet } from 'react-helmet';

var HelmetDetails = function HelmetDetails(_ref) {
  var title = _ref.title,
      description = _ref.description,
      siteImage = _ref.siteImage,
      siteImageAlt = _ref.siteImageAlt,
      priceCurrency = _ref.priceCurrency,
      priceAmount = _ref.priceAmount,
      robots = _ref.robots,
      keywords = _ref.keywords;
  return /*#__PURE__*/React.createElement(Helmet, null, title && /*#__PURE__*/React.createElement("title", null, title), description && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }), siteImage && /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: siteImage
  }), siteImageAlt && /*#__PURE__*/React.createElement("meta", {
    property: "og:image:alt",
    content: siteImageAlt
  }), priceCurrency && /*#__PURE__*/React.createElement("meta", {
    property: "og:price:currency",
    content: priceCurrency
  }), priceAmount && /*#__PURE__*/React.createElement("meta", {
    property: "og:price:amount",
    content: priceAmount
  }), robots && /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: robots
  }), keywords && /*#__PURE__*/React.createElement("meta", {
    name: "keywords",
    content: keywords
  }));
};

HelmetDetails.defaultProps = {
  title: undefined,
  description: undefined,
  siteImage: undefined,
  siteImageAlt: undefined,
  priceCurrency: undefined,
  priceAmount: undefined,
  robots: undefined,
  keywords: undefined
};
export default HelmetDetails;